export interface GuestStatistics {
  total: number;
  accepted: number;
  declined: number;
  invited: number;
  new: number;
  additional_guests: number;
  primary_guests: number;
}
export interface Guest {
  id: number;
  celebration_id: number;
  event_id?: number; // Optional - NULL for celebration-level guests
  user_id: number;
  name?: string; // From users table JOIN
  email?: string; // From users table JOIN  
  phone?: string; // From users table JOIN
  nickname?: string; // User's nickname from users table
  created_by?: number; // User ID who added this guest
  creator_nickname?: string; // Nickname of user who added this guest
  creator_name?: string; // Full name of user who added this guest
  host_user_id?: number; // Host owner user ID
  host_name?: string; // Host owner full name
  host_nickname?: string; // Host owner nickname
  rsvp_status: RSVPStatus;
  notes: string;
  responded_at: Date;
  created_at: Date;
  updated_at: Date;
  is_additional_guest_allowed: boolean;
  additional_guest_type: 'count' | 'named';
  additional_guest_count: number;
  is_primary_guest: boolean;
  invitation_token: string;
  invitation_sent_at: Date;
  invitation_expires_at: Date;
  access_token?: string;
  token_expires_at?: Date;
  primary_guest_user_id: number;
  primary_guest_name?: string; // Full name of primary guest (if additional guest)
  additional_guests: Guest[];
  primary_guest: Guest;
  dietary_restrictions?: string;
  deleted_at?: Date;
}

export const RSVPStatus = {
  YES: 'yes',
  NO: 'no',
  MAYBE: 'maybe',
  NO_RESPONSE: 'no_response',
  INVITED: 'invited',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  NEW: 'new'
} as const;

export type RSVPStatus = typeof RSVPStatus[keyof typeof RSVPStatus];

export interface CreateGuestDto {
  celebration_id: number;
  event_id?: number; // Optional - NULL for celebration-level guests
  user_id?: number;
  host_user_id?: number;
  user_contact_id?: number;
  name?: string; // Optional - can be fetched from users table via user_id
  email?: string;
  phone?: string;
  dietary_restrictions?: string;
  rsvp_status?: RSVPStatus;
  primary_guest_user_id?: number;
  is_additional_guest_allowed?: boolean;
  additional_guest_type?: 'count' | 'named';
  additional_guest_count?: number;
  is_primary_guest?: boolean;
  notes?: string;
}

export interface UpdateGuestDto {
  user_id?: number;
  name?: string;
  rsvp_status?: RSVPStatus;
  is_additional_guest_allowed?: boolean;
  additional_guest_type?: 'count' | 'named';
  additional_guest_count?: number;
  notes?: string;
  responded_at?: string;
  updated_at?: string;
}

export interface AddAdditionalGuestByCountDto {
  additional_count: number;
}

export interface AddAdditionalGuestByNameDto {
  additional_guests: {
    name: string;
    // Optionally add notes, etc.
  }[];
}

export interface GuestInvitationResponseDto {
  invitation_token: string;
  rsvp_status: RSVPStatus;
  additional_guest_response?: AddAdditionalGuestByCountDto | AddAdditionalGuestByNameDto;
  notes?: string;
}
